module.exports = __webpack_public_path__ + "images/icons_v2/location-map-juul-f2afccbe.svg";